module.exports = __webpack_public_path__ + "static/img/ihago.6a078822.png";